module.exports = __webpack_public_path__ + "img/Marek Kirejczyk.267178b6.jpg";